export const clearExperimentViews = state => ({
  ...state,
  viewedOnPage: [],
});
